export default {
  'define-a-problem': {
    'course-title': 'How To Define A Problem',
    'course-name': 'Section 5A <span class="unit-title">How To Define A Problem<span>',
    'course-video': {
      'title': 'Section 5 DEFINING THE PROBLEM<br/>1’47:35 – 1’58:08 5A OVERVIEW OF A PROCESS :<br/>- Ex 5A step by step process in action',
      'src': 'https://www.youtube.com/embed/5aov7rXM3Vw?enablejsapi=1',
      'lecture-title': '5A Lecture'
    },
    'unit-section-title': '5A Exercises',
    'intro': `<p>As I just said, once you have defined the problem structure, it is dead easy to write your own introduction. You simply read from left to right and down, and the last thing you come to that is known by the reader, is always the Complication in your story.
</p>
<br/>
<p class="diagram-title">THE PROBLEM DEFINITION FRAMEWORK</p>
<br/><br/>
<div class="desc-diagram-wrapper">
    <div style="max-width: 340px;" class="desc-diagram-wrapper__content-block">
        <p style="margin-left: 15px;">Opening Scene</p>
        <div class="block">
            Describe the arena within which the problem takes place
        </div>
    </div>
    <div class="arrowAnim">
      <div class="arrowSliding">
        <div class="arrow"></div>
      </div>
      <div class="arrowSliding delay1">
        <div class="arrow"></div>
      </div>
      <div class="arrowSliding delay2">
        <div class="arrow"></div>
      </div>
      <div class="arrowSliding delay3">
        <div class="arrow"></div>
      </div>
    </div>
<!--    <svg style="z-index: 2; margin-top: 8px;" width="150" height="150">-->
<!--       <path class="desc-diagram-wrapper__block__path" d="M 1 60 L 90 60 L 90 45 L 135 65 L 90 85 L 90 70 L 1 70 Z"></path>-->
<!--    </svg>-->
    <div class="desc-diagram-wrapper__block">
        <div style="display: flex; justify-content: center">
            <div style="max-width: 194px;" class="desc-diagram-wrapper__content-block">
                <p style="text-align: center">R1</p>
                <div class="block">
                    What will happen with the current trajectory?
                </div>
            </div>
                <div class="arrowAnim">
                  <div class="arrowSliding">
                    <div class="arrow"></div>
                  </div>
                  <div class="arrowSliding delay1">
                    <div class="arrow"></div>
                  </div>
                  <div class="arrowSliding delay2">
                    <div class="arrow"></div>
                  </div>
                  <div class="arrowSliding delay3">
                    <div class="arrow"></div>
                  </div>
                </div>
<!--            <svg style="z-index: 2; width: 150px;margin: 8px -12px 0;">-->
<!--               <path class="desc-diagram-wrapper__block__path" d="M 1 60 L 90 60 L 90 45 L 135 65 L 90 85 L 90 70 L 1 70 Z"></path>-->
<!--            </svg>-->
            <div style="max-width: 194px;" class="desc-diagram-wrapper__content-block">
                <p style="text-align: center">R2</p>
                <div style="height: 80%" class="block">
                    What do you want instead?
                </div>
            </div>
        </div>
        <svg>
            <line x1="80" y1="0" x2="215" y2="100" />
            <line x1="355" y1="0" x2="215" y2="100" />
        </svg>
        <div class="arrowAnim arrowAnim-third">
          <div class="arrowSliding">
            <div class="arrow"></div>
          </div>
          <div class="arrowSliding delay1">
            <div class="arrow"></div>
          </div>
          <div class="arrowSliding delay2">
            <div class="arrow"></div>
          </div>
          <div class="arrowSliding delay3">
            <div class="arrow"></div>
          </div>
        </div>
<!--        <svg style="z-index: 2;-->
<!--            max-width: 150px;-->
<!--            margin-top: 160px;-->
<!--            margin-left: 95px;-->
<!--            position: absolute;-->
<!--            transform: rotate(142deg)">-->
<!--           <path class="desc-diagram-wrapper__block__path" d="M 1 60 L 90 60 L 90 45 L 135 65 L 90 85 L 90 70 L 1 70 Z"></path>-->
<!--        </svg>-->
        <div style="max-width: 194px;" class="desc-diagram-wrapper__content-block">
            <p style="text-align: center">SOLUTION</p>
            <div class="block">
                How will you get from R1 to R2?
            </div>
        </div>
    </div>
</div>
<br/><br/>
<br/><br/>
<p>To help you get used to this new framework, let us take you step by step through the process for defining the problems for two different levels of complexity.</p>`,
    'menu-list': {
      'exercise-1': 'Purchasing at Orlando',
      'exercise-2': 'The Rationalization Program'
    },
    'exercise-description': 'Step-by-Step Process for Defining a Problem',
    'exercise-1': {
      'title': '5A - Example 1.<br/>Purchasing at Orlando',
      'text-1': '<p style="margin: 25px 0">Let’s look at how you would use it to define the problem in the Orlando exercise you worked through in the previous section (4C-2).</p>',
      'blue-paper': `<p>Orlando is a large company with several divisions. You have been told by your new vice president that he wants to make sure from now on the company does business only with qualified suppliers.</p>
    <br/>
    <p><strong>1. Orlando has no centralized purchasing function,</strong> nor has it ever developed a formal supplier evaluation or qualification process that consistently applies throughout the organization.  Each division makes its own decisions on who should supply its particular products and services, to a total of $600 million every year.  This $600 million covers a wide variety of materials, from hundreds of different suppliers, selected by people with widely differing backgrounds.</p>
    <br/>
    <p><strong>2. The vice president believes that many of its suppliers have come to the point where they consider selling to Orlando to be their right,</strong> rather than a hard won privilege. “We want to do business only with competent suppliers who are interested in keeping our business,” he said. “Otherwise, we risk paying much more for things than necessary, while getting less than outstanding service.”</p>
    <br/>
    <p><strong>3. He believes the company needs a standard process for evaluating, qualifying, and developing suppliers,</strong> so that he can be sure the company gets the highest quality products and services at the lowest reasonable price.</p>`,
      'text-2': `<p>You remember that you came up with this pyramid and basic introduction.</p><br/>
        <div class="desc-scq-diagram">
            <div class="scq-text">
                <div class="scq-block">
                    <p>S =</p>
                </div>
                <div class="scq-block">
                    <p>C =</p>
                </div>
                <div class="scq-block">
                    <p>Q =</p>
                </div>
            </div>
            <div class="scq-diagram">
                <div class="scq-block">
                    <p>Source products and services only from qualified suppliers</p>
                </div>
                <svg>
                    <line x1="450" y1="0" x2="85" y2="100"/>
                    <line x1="450" y1="0" x2="325" y2="100"/>
                    <line x1="450" y1="0" x2="575" y2="100"/>
                    <line x1="450" y1="0" x2="810" y2="100"/>
                </svg>
                <div class="scq-diagram-body">
                <div class="scq-block">
                    <p>Identify the qualified suppliers available to you</p>
                </div>
                <div class="scq-block">
                    <p>Determine a means of choosing between them</p>
                </div>
                <div class="scq-block">
                    <p>Evaluate performance against clear criteria</p>
                </div>
                <div class="scq-block">
                    <p>Periodically review need for new suppliers</p>
                </div>
                </div>
            </div>
        </div>
        <br/><br/>
    <p>But first you have to write an introduction that defines for the rest of the organization the problem that requires them to adopt this new process.</p>`,
      'text-3': '<p style="margin-top: 20px"><strong>Let me take you through the problem definition process.</strong></p>',
      'text-4': '<p>Now you have a very clear picture of the problem and its solution in your mind. You also have an indication of the question that document has to be structured to answer. You are ready to write.</p>',
    },
    'intro-2': '<p>All it takes is a little practice for you to get used to this very useful technique. Let’s try another one, following the same process of pushing the buttons to fill in the form. You will recall the Data Center Relocation memo.</p>',

    'exercise-2': {
      'title': '5A - Example 2.<br/>The Rationalization Program',
      'text-1': `<p>WHAT YOU KNOW</p><br/><p>You will recall that a New Zeland bank had hired a team of 6 consultants to find $72m worth of cost savings throughout their 173 branch network. It had identified 822 separate projects across the branch network to be completed in 12 months. The team began work in July, planning to end in June when their visas ran out.It is now late November, and they have completed only 30 branches – i.e., they have spent 41% of the time allotted to do 17% of the work required. There is no chance of adding additional manpower or extending the product time.</p>
       <br/>
       <p>As with the Orlando example, you want to begin by visualizing the Situation. What do we know about what is going on now with our work.</p>
       <ul>
         <li>- We know we need to complete 822 projects</li>
         <li>- We know we have done only 30 branches out of 173</li>
         <li>- We will never achieve the $72m savings by the end of the product</li>
         <li>- We cannot extend the time, nor expand the team</li>
         <li>- We think we might be able nonetheless to achieve a big percentage of the cost savings in the remaining time</li>
       </ul>`,
      'text-2': `In the final step shown in the Minto Framework should look like this:`,
    },
    'congratulation-message': 'excellent',
    'finish-section': 'You have completed Section 5A',
    'final-description': 'You understand how the Problem Definition Framework<br/>presents a map for structuring an introduction',
    'next-course-button': 'proceed to section 5B',
    'dashboard-button': 'Main menu',
  }
}



// WEBPACK FOOTER //
// ./client/app/modules/courses/5/5a/defineProblem/i18n/en.js